var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('p',{staticClass:"text"},[_vm._v(" Un momento...")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }